import React from 'react';
import { IconDrawPath } from './styles';

type IconProps = {
  isVisible: boolean;
};

const pathClass = (isVisible: boolean) => ({ $isVisible: isVisible });

export const IconCompareQuotes: React.FC<IconProps> = ({ isVisible }) => (
  <svg
    width="245"
    height="150"
    viewBox="0 0 245 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <IconDrawPath
      d="M134.109 66.256C140.946 57.1822 153.07 66.2051 144.428 79.3709C138.252 88.7497 132.38 99.323 126.712 108.041C126.712 108.041 125.391 115.971 128.136 121.791C133.499 133.254 147.732 133.737 155.204 127.815C164.253 120.597 166.845 103.11 154.289 99.8821C143.005 96.9592 136.117 117.42 160.186 116.428C178.334 115.691 179.884 126.646 179.884 126.646"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
    <IconDrawPath
      d="M79.3868 124.308C79.3868 109.388 69.9827 101.484 69.9827 87.6573V72.8902C69.9827 61.0461 83.6822 61.0461 83.6822 72.8902V74.1356V62.7998C83.6822 50.8032 97.4072 51.9469 97.4072 62.7998C97.4072 68.849 97.4072 64.0707 97.4072 65.1127V56.0899C97.4072 44.4236 112.403 43.1274 112.403 56.0899V64.4519V28.5128C112.403 16.2112 126.585 15.9062 126.585 28.5128C126.585 36.5699 126.84 49.202 126.585 63.969C126.56 66.0277 126.585 70.2215 126.585 72.3819"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
  </svg>
);

export const IconGetAdvice: React.FC<IconProps> = ({ isVisible }) => (
  <svg
    width="245"
    height="150"
    viewBox="0 0 245 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <IconDrawPath
      d="M134.463 66.7305C138.538 73.9125 139.607 86.4057 135.398 94.4561C127.448 109.555 112.383 117.004 92.6741 118.006L75.1368 133.84V115.234C63.3451 111.726 47.0772 99.6672 47.1106 81.2948C47.1775 44.9509 94.4445 36.6333 116.224 46.2537C127.982 51.4648 123.439 64.292 114.32 62.2544C106.637 60.5507 105.368 50.0284 107.572 44.5835C115.122 25.9105 133.594 16.6241 153.47 16.5239C180.728 16.3903 196.561 30.6873 197.797 48.9929C198.8 63.6907 191.718 78.6893 171.441 86.8065V105.68C171.441 105.68 165.662 99.3999 154.372 90.0467C154.372 90.0467 145.553 90.2137 139.908 88.5769"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
  </svg>
);

export const IconBuyPolicy: React.FC<IconProps> = ({ isVisible }) => (
  <svg
    width="245"
    height="150"
    viewBox="0 0 245 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <IconDrawPath
      d="M110.948 124.121H73.9053C67.7226 124.201 61.54 119.218 61.54 108.958V101.709H122.353V108.958C122.353 129.451 147.057 128.892 147.057 108.958V51.3692C147.057 32.8214 123.686 43.5343 134.505 55.1534C145.325 66.7724 158.41 57.0454 166.911 52.1687C175.412 47.2919 183.46 51.4491 183.46 51.4491"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
    <IconDrawPath
      d="M73.905 92.9421V26.2393H147.057"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
    <IconDrawPath
      d="M115.238 51.2891H90.854"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
    <IconDrawPath
      d="M124.459 67.3325H90.854"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
    <IconDrawPath
      d="M124.459 83.6685H90.854"
      stroke="#EB6424"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathClass(isVisible)}
    />
  </svg>
);
